import { Pipe, PipeTransform } from '@angular/core';
import { ITemplateFormMaster, VerticalEnum } from '@sml/utility';

@Pipe({ name: 'verticalPipe', standalone: true })
export class verticalPipe implements PipeTransform {
   transform(item: any): string {
        if (item?.verticals) {
            try {
                const verticalArray: number[] = JSON.parse(item.verticals);

                const verticals = verticalArray.map((num: number) => {
                    return VerticalEnum[num] ?? num;
                });

                return verticals.join(', ');
            } catch (error) {
                console.error('Invalid verticals format:', item.verticals);
                return '';
            }
        }
        return '';
    }
}
